export const iconFontAwesomeUsersPeoplePersonSkiingNordic = (
	<i className="fa-solid fa-person-skiing-nordic"></i>
);
